import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Obrigado from './components/Obrigado';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/obrigado" element={<Obrigado />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;